import { IonIcon, IonPage, IonText, isPlatform } from "@ionic/react";
import { FPC_FCM_DUMMY_URL, PAGE_TITLES } from "../../../utils/constants";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import "./notificationcontainer.scss";
import { createStructuredSelector } from "reselect";
import {
  updateNotificationBellIconState,
  updateStatusofNotification,
  updateNewToUnreadNotifications,
  setDynamicLinkParams
} from "../../../actions/App/action";
import {
  getUserMasterData,
  getWebNotificationsData
} from "../../../selectors/selector";
import {
  confirmTransferRequest,
  transferRequestReset
} from "../../../actions/manage/action";
import { SCREEN, EVENT } from "../../../utils/constants.analytics";
import { logEvent } from "../../../utils/Analytics";
import { Roles } from "../../../utils/constants";
import { GPSWrapper, clear, IONICWrapper, deepLinkObjCreation } from "../../../utils/common";
import { EnumType } from "json-to-graphql-query";
import { useTranslation } from "react-i18next";
import { UserDetails } from "../../../models/userProfile/userProfile.modal";
import { ToastMessage } from "../../../utils/ToastMessage";
import { useAuthService } from "../../../services/Auth";
import useInjectSaga from "../../../utils/injectSaga";
import useInjectReducer from "../../../utils/injectReducer";
import reducer from "../../../reducers/manage/reducer";
import saga from "../../../saga/Manage/saga";
import { compose } from "redux";
import { CustomModalWeb } from "../../pages/userProfile/CustomModalWeb";
import { store } from "app/store";

const NotificationContainer = (props: any) => {
  const { notificationsData } = props.getWebNotificationsData;
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const authService = useAuthService();

  const [showMenu, setShowMenu] = useState(false);
  const [notificationId, setNotificationId] = useState<any>(null);

  const getNewNotificationsArray = () => {
    return notificationsData.filter(
      (item: any) => item.notificationStatus === "NEW"
    );
  };

  useEffect(() => {
    props.updateNotificationBellIconState(true);
    if (notificationsData.length > 0) {
      props.updateNewToUnreadNotifications([...getNewNotificationsArray()]);
    }
    return () => {
      props.updateNotificationBellIconState(false);
    };
  }, []);

  const getTimeString = (time: string) => {
    let arr = time.split(" ");
    let lastIndex = arr.length - 1;
    return `${arr[0] || ""} ${arr[1] || ""} ${arr[lastIndex] || ""}`;
  };

  const [showViewAlert, onShowViewAlert] = useState<boolean>(false);
  const [showAgreeAlert, onShowAgreeAlert] = useState<boolean>(false);
  const [message, onSetMessage] = useState<any>({});

  const handleTransfer = (confirm: boolean) => {
    const { userDetails } = props;
    const transferDetails: any = (message?.data) || {};
    const roles =
      (transferDetails.roles && [new EnumType(transferDetails.roles)]) || [];
    const payload = {
      userId:userDetails?.memberDetailsResponse?.member?.upn,
      carrierId: transferDetails.requestedCarrierId,
      confirm,
      roles
    };
    confirmTransfer(payload);
  };

  async function azureLogout() {
    if (isPlatform("capacitor")) {
      GPSWrapper.details.stopGPS();
    }
    await clear();
    await authService.logout();
    await props.logout();
  }

  const confirmTransfer = (payload: any) => {
    const userProfileModel = new UserDetails();
    const query = userProfileModel.confirmTransfer(payload);
    const callback = async (status = false,message : string) => {
      // Analytics implementation
      if (!status) {
        ToastMessage.show(message || t("OOPS_MESSAGE"));
        // Analytics implementation for New Carrier Request Modal -> Agree ->failed (on member API response)
        logEvent(
          IONICWrapper.details.auth.user.roles.includes(Roles.carrierGuest)
            ? EVENT.UE_GUEST_CARRIERREQ_FAILURE
            : EVENT.UE_CARRIERREQ_FAILURE,
          {
            screen: SCREEN.NEWCARRIERREQUEST
          }
        );
      }
      if (status && payload.confirm) {
        await azureLogout();
        // Analytics implementation for New Carrier Request Modal -> Agree (on member API response)
        logEvent(
          IONICWrapper.details.auth.user.roles.includes(Roles.carrierGuest)
            ? EVENT.UE_GUEST_CARRIERREQ_AGREED
            : EVENT.UE_CARRIERREQ_AGREED,
          {
            screen: SCREEN.NEWCARRIERREQUEST
          }
        );
        return true;
      }
      props.transferRequestReset();
    };
    props.confirmTransfer({ query, callback });
  };
  const notificationMessagesProps = {
    isModalOpen: showViewAlert,
    title:
      (message?.notification?.title) ||
      "Driver Assigned",
    message_content:
      (message?.notification?.body) || "",
    size: "small_height",
    buttons: [
      {
        title: t("View Later"),
        type: "secondary-cta-btn-web",
        onClick: () => {
          onSetMessage({});
          onShowViewAlert(false);
        }
      },
      {
        title: t("View Now"),
        type: "primary-cta-btn-web",
        onClick: () => {
          onShowViewAlert(false);
          onShowAgreeAlert(true);
        }
      }
    ]
  };
  const confirmTransferProps = {
    isModalOpen: showAgreeAlert,
    title: t("MANAGE_USER_CONFIRM_TRANSFER_TITLE"),
    message_content:t("MANAGE_USER_CONFIRM_TRANSFER_MESSAGE").replace('COMPANY', (message?.data?.carrierName)),
    size: "small_height",
    buttons: [
      {
        title: t("Not Now"),
        type: "secondary-cta-btn-web",
        onClick: () =>{
          props.transferRequestReset();
          handleTransfer(false);
          onShowAgreeAlert(false);
          //Analytics implementation
          logEvent(
            IONICWrapper.details.auth.user.roles.includes(
              Roles.carrierGuest
            )
              ? EVENT.UE_GUEST_CARRIERREQ_NOTNOW
              : EVENT.UE_CARRIERREQ_NOTNOW,
            {
              screen: SCREEN.NEWCARRIERREQUEST
            }
          );
        }
      },
      {
        title: t("Agree"),
        type: "primary-cta-btn-web",
        onClick: () =>{
          handleTransfer(true);
          onShowAgreeAlert(false);
          onShowViewAlert(false);
        }
      }
    ]
  };
  return (
    <IonPage className="desktop-page">
      <h1 className="heading-search">{PAGE_TITLES.NOTIFICATIONS}</h1>
      <CustomModalWeb {...notificationMessagesProps} />
      <CustomModalWeb {...confirmTransferProps} />
      <div className="notification-container">
        {notificationsData?.map((item: any, index: number) => (
            <React.Fragment key={item.vendorMessageID}>
              <div
                className="notification-item-container"
                onClick={() => {
                  if (
                    item?.message?.data?.type == "MANAGE_USER_REQUEST"
                  ) {
                    onSetMessage(item.message);
                    onShowViewAlert(true);
                  } else {
                    const deepLinkURL = item.message.data.deepLinkURI;
                    if (deepLinkURL.indexOf("?") >= 0) {
                      const deepLinkURL = FPC_FCM_DUMMY_URL + item.message.data.deepLinkURI;
                      const params = (new URL(deepLinkURL)).searchParams;
                      const deepLinkURI: any = params.get('deepLinkURI');
                      const paramsDict: any = params.get('params');
                      store.dispatch(setDynamicLinkParams({
                        paramsDict: paramsDict ? {
                          ...deepLinkObjCreation(paramsDict)
                        } : null,
                        deepLinkURI: deepLinkURI
                      }));
                    } else {
                      const deepLinkURI = "/app/MyLoad";
                      const paramsDict = { shipmentId: item.message.data.shipmentId };
                      store.dispatch(setDynamicLinkParams({
                        paramsDict: paramsDict,
                        deepLinkURI: deepLinkURI
                      }));
                    }
                  }
                }}
              >
                <div className="left-body-part">
                  <IonText className="notification-body-text">
                    <span className="body-title">{item.message.notification.title}</span>
                  </IonText>
                  <IonText className="body-text">
                    {item.message.notification.body}
                  </IonText>
                </div>
                <div className="right-body-part">
                  <div
                    className="dot-container"
                    onClick={e => {
                      e.stopPropagation();
                      setNotificationId(showMenu ? null : item.vendorMessageID);
                      setShowMenu(!showMenu);
                    }}
                  >
                    <div className="dot"></div>
                  </div>
                  <IonText className="time-text">
                    {getTimeString(item.message.data.notificationAge)}
                  </IonText>
                  {showMenu && notificationId === item.vendorMessageID && (
                    <div className="popup-shadow-wrapper">
                      <div
                        className="delete-popup"
                        onClick={e => {
                          e.stopPropagation();
                          props.updateNotificationStatus({
                            vendorMessageID: item.vendorMessageID,
                            notificationPayload: {
                              ...item,
                              notificationStatus: "DELETED"
                            }
                          });
                          setShowMenu(!showMenu);
                        }}
                      >
                        <IonIcon src="assets/icon/delete_orange.svg" />
                        <div className="delete-textbox">
                          <div className="delete-text">Delete</div>
                          <div className="delete-textdesc">
                            Delete this notification
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {index !== notificationsData.length - 1 ? (
                <hr className="hr-tag" />
              ) : null}
            </React.Fragment>
          ))}
        {notificationsData.length === 0 && (
          <div className="no_notifications_present">
            There are no notifications present for the user.
          </div>
        )}
      </div>
    </IonPage>
  );
};

const mapStateToProps = createStructuredSelector({
  getWebNotificationsData: getWebNotificationsData(),
  userDetails: getUserMasterData()
});

export const mapDispatchToProps = (dispatch: any) => ({
  transferRequestReset: () => dispatch(transferRequestReset()),
  confirmTransfer: (payload: any) => dispatch(confirmTransferRequest(payload)),
  updateNotificationBellIconState: (payload: any) =>
    dispatch(updateNotificationBellIconState(payload)),
  updateNotificationStatus: (payload: any) =>
    dispatch(updateStatusofNotification(payload)),
  updateNewToUnreadNotifications: (payload: any) =>
    dispatch(updateNewToUnreadNotifications(payload))
});
const key = "manage";
const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = useInjectReducer({ key, reducer });
const withSaga = useInjectSaga({ key, saga });

export default compose(
  withSaga,
  withReducer,
  withConnect
)(NotificationContainer);